var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"id":"signPage"}},[_c('Header',{ref:"header"}),_c('div',{attrs:{"id":"content"}},[_c('keep-alive',{attrs:{"exclude":"Privacy"}},[_c('router-view',{on:{"getLangOptions":_vm.getLangOptions,"initHeader":_vm.initHeader}})],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }